module.exports = __webpack_public_path__ + "img/pclogotype.59c0c23f.webp";